import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/karla/200.css';
import '@fontsource/karla/400.css';
import '@fontsource/karla/500.css';
import '@fontsource/karla/700.css';
import '@fontsource/karla/800.css';
import '@fontsource/markazi-text/400.css';
import '@fontsource/markazi-text/500.css';
import '@fontsource/markazi-text/600.css';
import '@fontsource/markazi-text/700.css';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
